/**
 * Retrieves the global TinyMCE instance from a given window object, if available.
 *
 * @param {Window} view - The window from which to extract the TinyMCE instance.
 * @returns {TinyMCE | null} The TinyMCE instance if found, otherwise `null`.
 */
const getTinymce = (view) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = view;
    return global && global.tinymce ? global.tinymce : null;
};
export { getTinymce };
